<script setup>
import { ref, computed, watch } from "vue";
import { storeToRefs } from "pinia";
import { useCriarQuestoesStore } from "@/store/criarQuestoes";

import Dialog from "primevue/dialog";
import Chip from 'primevue/chip';


const store = useCriarQuestoesStore();
const { modeloQuestaoSelecionado, tipoPerguntaSelecionada, fonteDadosParaQuestao, modelosQuestoes} = storeToRefs(store);
const visible = ref(false);

const selecionaModelo = (modelo) => {
    modeloQuestaoSelecionado.value = modelo
    visible.value = false
}

watch([tipoPerguntaSelecionada, fonteDadosParaQuestao], () => {
    let modelosDisciponiveis = modelosQuestoes.value.filter(modelo => modelo.fonte_dados === fonteDadosParaQuestao.value);
    let modelos = modelosDisciponiveis.filter(modelo => modelo.tipo_questao === 0 || modelo.tipo_questao === tipoPerguntaSelecionada.value);
    modeloQuestaoSelecionado.value = modelos[0]
})

const criterioTaxonomiaSelecionado = ref(null);

const modelosFiltrados = computed(() => {
    let modelosFiltradosPorFonte = modelosQuestoes.value.filter(modelo => modelo.fonte_dados == fonteDadosParaQuestao.value);
    let modelosFiltradosPorTipoQuestao = modelosFiltradosPorFonte.filter(modelo => modelo.tipo_questao === 0 || modelo.tipo_questao === tipoPerguntaSelecionada.value);
    if (criterioTaxonomiaSelecionado.value !== null) {
        return modelosFiltradosPorTipoQuestao.filter(item => item.nivel_complexidade === criterioTaxonomiaSelecionado.value);
    }
    return modelosFiltradosPorTipoQuestao;
    
})

const tituloModelo = computed(() => {
    let modelo = modelosQuestoes.value.find(modelo => modelo.id == modeloQuestaoSelecionado.value.id);
    return modelo.titulo
})

const descricaoModelo = computed(() => {
    let modelo = modelosQuestoes.value.find(modelo => modelo.id == modeloQuestaoSelecionado.value.id);
    return modelo.descricao
})

</script>
<template>
    <div class="flex flex-column gap-2" v-if="modelosQuestoes.length > 0">
        <label class="flex justify-content-between align-items-center">
            <div>
                Modelo de questão
            </div>
            <div>
                
            </div>
        </label>
        <div class="flex flex-column gap-2 border border-1 border-gray-300 p-1 border-round-md  cursor-pointer"
            @click="visible = true">
            <div class="hover:surface-100 p-3 border-round-md flex flex-column gap-2">
                <div class="font-semibold">{{ tituloModelo }}</div>
                <div class="text-sm">{{ descricaoModelo }}</div>
            </div>
        </div>
    </div>

    <Dialog v-model:visible="visible" modal header="Selecione um modelo de questão" :style="{ width: '50vw' }"
        :breakpoints="{ '1199px': '75vw', '575px': '100vw' }" v-if="modelosQuestoes.length > 0">
        <div class="mb-4 flex gap-2 flex-wrap">
            <Chip label="Todas" class="cursor-pointer" @click="criterioTaxonomiaSelecionado = null" />
            <Chip label="Lembrar" class="cursor-pointer" @click="criterioTaxonomiaSelecionado = 1" />
            <Chip label="Compreender" class="cursor-pointer" @click="criterioTaxonomiaSelecionado = 2" />
            <Chip label="Aplicar" class="cursor-pointer" @click="criterioTaxonomiaSelecionado = 3" />
            <Chip label="Avaliar" class="cursor-pointer" @click="criterioTaxonomiaSelecionado = 4" />
        </div>
        <div class="flex flex-column gap-2 border border-1 border-gray-300 p-1 border-round-md">
            <div v-for="modelo in modelosFiltrados" :key="modelo.id">
                <div @click="selecionaModelo(modelo)"
                    class="border-round-md hover:surface-100 cursor-pointer flex flex-column gap-2 p-3">
                    <div class="font-semibold">{{ modelo.titulo }}</div>
                    <div class="text-sm">{{ modelo.descricao }}</div>
                </div>
            </div>
        </div>
    </Dialog>

</template>

